// extracted by mini-css-extract-plugin
export default {"wrapper":"WgeCr","content":"PcFZe"};